import { render, staticRenderFns } from "./sideNav.component.vue?vue&type=template&id=0e05164f&scoped=true&"
import script from "./sideNav.component.vue?vue&type=script&lang=js&"
export * from "./sideNav.component.vue?vue&type=script&lang=js&"
import style0 from "./sideNav.component.vue?vue&type=style&index=0&id=0e05164f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e05164f",
  null
  
)

export default component.exports